export class UsuarioLogado {
  id: number;
  email: string;
  nome: string;
  roles: string[];
  limDesc: number;
  verCustos: string;
  editaPedido: boolean;
  verExcel: boolean;
  podeEditarVendaDireta: boolean;
  verTodosPedidos: boolean;
  podeConfirmarPedido: boolean;
  podeAlterarLiderTime: boolean;
  idUsuarioIntegrador: number;
  verSomenteHierarquia: boolean;
  podeSimular: boolean;
  podeVerMensagem: boolean;
  podeVerMarkup: boolean;
  podeVerPesquisaGeral: boolean;
}
